<template>
  <div id="app" class="row" style="max-width: 100%;">
    <!-- <app-header-stocks></app-header-stocks> -->
    <!-- <app-header :quoteCount="quotes.length" :maxQuotes="maxQuotes"></app-header> -->
    <!-- <app-new-quote @quoteAdded="newQuote"></app-new-quote> -->
    <!-- <app-quote-grid :quotes="quotes" @quoteDeleted="deleteQuote"></app-quote-grid> -->
    <!-- <div class="col-sm-12 text-center">
      <div class="alert alert-info mt-4">Info: Click on a Quote to Delete it</div>
    </div> -->
    <!-- <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition> -->

    <div class="col-md-3" style="padding-right: 0;">
      <app-sidebar class="web-only"></app-sidebar>
      <app-mobile-sidebar class="mobile-only" style="margin-right: -30px;"></app-mobile-sidebar>
    </div>
    <div class="col-md-9" style="padding-right: 0; margin-top: 15px; margin-bottom: 15px;">
      <router-view></router-view>
    </div>

  </div>
</template>

<script>
  import gmapsInit from './utils/gmaps';

  import QuoteGrid from './components/QuoteGrid.vue';
  import NewQuote from './components/NewQuote.vue';
  import Header from './components/Header.vue';
  import HeaderStocks from './components/HeaderStocks.vue';

  import Sidebar from './components/myrundash/Sidebar.vue';
  import MobileSidebar from './components/myrundash/MobileSidebar.vue';

  export default {
    data () {
      return {
        quotes: [
          'Just a starter quote.',
          'And another'
        ],
        maxQuotes: 10,
        user: {},
      }
    },
    created() {
      // Bugsnag.notify(new Error('Test error'))
    },
    methods: {
      newQuote(quote) {
        if (this.quotes.length >= this.maxQuotes) {
          return alert('Please delete quotes firts')
        }
        this.quotes.push(quote);
      },
      deleteQuote(index) {
        this.quotes.splice(index, 1);
      },
      getUser() {

      },
    },
    components: {
      appQuoteGrid: QuoteGrid,
      appNewQuote: NewQuote,
      appHeader: Header,
      appHeaderStocks: HeaderStocks,

      appSidebar: Sidebar,
      appMobileSidebar: MobileSidebar,
    },
    created() {
      this.$store.dispatch('initStocks');
      this.$store.dispatch('tryAutoLogin')
      this.getUser()
    }
  }
</script>

<style>

  :root {
    --coredarkcolor: #183a52;
    --coredarkercolor: #11293b;
    --corelightcolor: #5e8dad;
    --bootstrapgrey: #e9ecef;
    --skyblue: #bfe7ff;
    --MDI: #330065;
    --Ryerson: #002d72;
    --JKR: #183a52;
  }

  /* ------ FONTS ------- */
  #app {
    font-family: 'Lato', 'Open Sans', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1 {
    font-family: 'Lato';
  }
  h2 {
    font-family: 'Lato';
  }
  h3 {
    font-family: 'Lato';
  }

  .section-title {
    color: #fff;
    font-weight: 700;
  }

  .dashboard-header {
    text-transform: uppercase;
    font-weight: 400;
    color: #000;
    font-size: 21px;
  }
  /* -------------------------------- */

  /* ---------------- ANIMATION ---------------- */
  /* Lecture 299 */
  .slide-enter-active {
    animation: slide-in 200ms ease-out forwards;
  }

  .slide-leave-active {
    animation: slide-out 200ms ease-out forwards;
  }

  @keyframes slide-in {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from {
      transform: translateY(0px);
      opacity: 1;
    }
    to {
      transform: translateY(-30px);
      opacity: 0;
    }
  }
  /* -------------------------------- */

  /* ------ BUTTONS ------- */
  .btn-primary {
    background-color: #183a52;
    border-color: #183a52;
  }
  .btn-primary:hover {
    background-color: #49759c;
    border-color: #49759c;
  }

  .btn-mdi {
    /* background-color: #401D6C; */
    /* border-color: #401D6C; */
    background-color: var(--MDI);
    border-color: var(--MDI);
    color: white;
  }
  .btn-mdi:hover {
    background-color: #49759c;
    border-color: #49759c;
    color: white;
  }

  .mylisting-button {
    min-width: 165px;
    text-align: center;
    font-family: 'Montserrat';
    font-weight: 800;
    /* margin-top: 20px; */
    padding: 13px 25px;
    border-radius: 3px;
    font-size: 15px;
    /* height: 48px; */
    -webkit-box-align: center;
    align-items: center;
    position: relative;
    z-index: 0;
    -webkit-box-pack: center;
    justify-content: center;
    white-space: nowrap;
    font-weight: 700;
    border: none;
    /* margin-top: 10px; */
    /* background-size: 200% 100%;
    background-position: right bottom;
    transition: all .25s ease-out; */
  }

  /* This is to get rid of underlining for router links used as buttons */
  a.mylisting-button:hover {
    text-decoration: none;
  }

  .dark-button {
    color: #fff;
    /* Add a shadow over the search button left to right when you hover over it */
    /* https://codepen.io/kay8/pen/azKbjN */
    /* https://stackoverflow.com/questions/17212094/fill-background-color-left-to-right-css */
    background: linear-gradient(to right, var(--coredarkercolor) 50%, var(--coredarkcolor) 50%);
    background-size: 200% 100%;
    background-position: right bottom;
    transition: all .25s ease-out;
  }
  .dark-button:hover {
    color: #fff;
    background-position: left bottom;
  }

  /* -------------------------------- */

  .accordion {
    /* max-width: 400px; */
    font-family: Lato;
    margin-bottom: 8px;

    background-color: var(--coredarkcolor);
    border-radius: 3px;
    /* border-bottom-left-radius: 0px; */
    /* border-bottom-right-radius: 0px; */
    /* border-bottom: 2px solid var(--coredarkcolor); */
    /* border-bottom: 3px solid white; */
  }

  .accordion .header {
    height: 40px;
    line-height: 40px;
    padding: 0 40px 0 8px;
    position: relative;
    color: #fff;
    cursor: pointer;
    font-weight: 700;
    font-size: 17px;
  }

  .accordion .body {
    overflow: hidden;
    background-color: #fff;
    /* border: 10px solid #ec5366; */
    border-top: 0;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    transition: 250ms ease-out;
  }

  .accordion .body-inner {
    padding: 8px;
    overflow-wrap: break-word;
  /*   white-space: pre-wrap; */
    /* Need to add extra padding at the bottom because if new items appear (like error messages or custom distance fields, the accordion doesn't change size to accomodate them) */
    padding-bottom: 110px;
  }

  /* ---------------- FORMS ---------------- */

  .user-profile label {
    font-weight: 700;
    margin-bottom: 3px;
    margin-top: 10px;
    color: #2F4F4F;
  }
  .user-profile .top-label {
    margin-top: 0;
  }
  .field-of-fields label {
    font-weight: 700;
    margin-bottom: 3px;
    margin-top: 10px;
    color: #2F4F4F;
  }
  .field-of-fields .top-label {
    margin-top: 0;
  }

  /* Classes that get attached to form fields that fail vuelidation */
  .invalid label {
    color: red;
  }
  .invalid small {
    color: red;
  }

  .unavailable {
    color: lightgrey;
  }

  /* There was a red box showing around number fields on FireFox if a number with a decimal was entered
  https://stackoverflow.com/questions/3809146/firefox-4-required-input-form-red-border-outline */
  /* input[type="number"]:invalid {
    box-shadow: none;
  } */
  :-moz-ui-invalid {
    box-shadow:none;
  }

  /* -- CALENDAR -- */
  .vdp-datepicker input {
    border-width: 0px;
    width: 100%; /* Make the inner date picking box fill the entire box */
  }
  .vdp-datepicker__calendar input[type="text"]:focus {
    box-shadow: none;
    border: none;
  }
  .vdp-datepickers input[type="text"]:focus {
    box-shadow: none;
    border: none;
  }
  .vdp-datepicker__calendar {
    border: none;
  }
  /* -------------------------------- */

  /* -- TEAMS -- */
  .myrundash {
    background-color: var(--coredarkcolor);
  }
  .MDI {
    background-color: var(--MDI)
  }
  .Ryerson {
    background-color: var(--Ryerson)
  }
  .JKR {
    background-color: var(--JKR)
  }
  /* -------------------------------- */

  /* https://laracasts.com/discuss/channels/vue/vue-modal-make-it-scrollable-instead-of-background */
  /* Restrict the height of modals so that they are fully visible on mobile */
  .v--modal-overlay.scrollable .v--modal-box {
    max-height: 80vh;
    overflow-y: auto;
  }

  .dashboard-button {
    background-color: var(--bootstrapgrey);
    background-color: lightgray;
    /* background-color: var(--bootstrapgrey); */
    /* background-color: var(--coredarkcolor); */
    color: white;
    /* margin-right: 2px; */
    border-right: 2px solid white;
    padding-top: 6px;
    padding-bottom: 6px;
    cursor: pointer;
  }
  .dashboard-button-active {
    background-color: var(--coredarkcolor);
    color: white;
    /* margin-right: 2px; */
    /* padding-top: 6px; */
    /* padding-bottom: 6px; */
  }

/* ------------------- AUTHENTICATION FORMS ------------------- */
/* Bootstrap sign up form */
/* https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/signin.css */

  .authentication-form {
    height: calc(100vh - 30px); /* There is a 15px margin top and bottom */
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-authentication {
    width: 100%;
    max-width: 330px;
    /* min-width: 300px; */
    padding: 15px;
    margin: auto;
  }
  .form-authentication .checkbox {
    font-weight: 400;
  }
  .form-authentication .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-authentication .form-control:focus {
    z-index: 2;
  }

  /* --------------------------------------------------------- */

  @media (max-width: 1370px) {
    .dashboard-header.medium-shrink {
      font-size: 19px;
    }
  }

  @media (max-width: 1235px) {
    .medium-shrink h1 {
      font-size: 3px;
    }
    h1 {
      font-size: 2rem;
    }

    .dashboard-header.medium-shrink {
      font-size: 16px;
    }
  }

  .mobile-only {
    display: none;
  }

  @media (max-width: 768px) {
    .web-only {
      display: none;
    }
    .mobile-only {
      display: inherit;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue